import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

import "./Carousel.scss";

const CarouselItem = ({
	children,
	totalItemCount,
}) => {
	return (
		<div
			className={classnames({
				"payment-carousel-item": true,
			})}
			style={{ width: `${100 / totalItemCount}%` }}
		>
			{children}
		</div>
	);
};

CarouselItem.propTypes = {
	children: PropTypes.node,
	totalItemCount: PropTypes.number,
};

export default CarouselItem;



// WEBPACK FOOTER //
// ./src/apps/payment/components/Carousel/CarouselItem.jsx